export const FIXED_COST_CATEGORIES_ORDER = [
  "SALAIRES",
  "CHARGES_SOCIALES",
  "SOUS_TRAITANCE",
  "OUTILS_SAAS",
  "CRM_JOBBOARDS",
  "MARKETING_COMM",
  "LOCAUX",
  "IT_MATERIEL",
  "COMPTA_JURIDIQUE",
  "ASSURANCES",
  "DEPLACEMENTS",
  "FORMATION",
  "BANQUE_FINANCE",
  "DIRECTION",
  "AUTRES",
];

export const FIXED_COST_CATEGORY_LABELS_FR = {
  SALAIRES: "Salaires",
  CHARGES_SOCIALES: "Charges sociales",
  SOUS_TRAITANCE: "Sous-traitance",
  OUTILS_SAAS: "Outils / SaaS",
  CRM_JOBBOARDS: "CRM / Jobboards",
  MARKETING_COMM: "Marketing / Communication",
  LOCAUX: "Locaux / Loyer",
  IT_MATERIEL: "IT / Matériel",
  COMPTA_JURIDIQUE: "Compta / Juridique",
  ASSURANCES: "Assurances",
  DEPLACEMENTS: "Déplacements",
  FORMATION: "Formation",
  BANQUE_FINANCE: "Banque / Finance",
  DIRECTION: "Direction / Gouvernance",
  AUTRES: "Autres",
};

export const getCategoryLabel = (category) =>
  FIXED_COST_CATEGORY_LABELS_FR[category] || category || "—";

